import store from '@/store';

// One user bootstrap per page load, shared by the two callers that only need the
// company resolved: App.vue's boot and the router guard, which has to wait on it
// before it can tell "this account has no company" from "we haven't looked yet".
// The promise is kept after it settles, so whichever of the two runs first is the
// only round trip.
//
// Signup keeps dispatching actionInitUser directly: FinishingSignUp re-inits on
// purpose once the company is created mid-session, and handing it a memo from
// before that would resolve to the company-less answer and lock the app (TT-7152).
let bootstrap = null;

export function bootstrapUserOnce() {
  if (!bootstrap) {
    bootstrap = store.dispatch('user/actionInitUser');
  }
  return bootstrap;
}
